import { useEffect, useState } from "react";

/**
 * The seconds left until `until`, re-rendering once a second while it is in the future. Read from
 * the clock at render (not from the last tick), so a deadline set just now shows its full length.
 */
export function useSecondsLeft(until: number): number {
  const [, setTick] = useState(0);
  useEffect(() => {
    if (until <= Date.now()) return;
    const t = setInterval(() => {
      setTick((n) => n + 1);
      if (Date.now() >= until) clearInterval(t);
    }, 1000);
    return () => {
      clearInterval(t);
    };
  }, [until]);
  return Math.max(0, Math.ceil((until - Date.now()) / 1000));
}
